import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tbody[appTbody]',
  templateUrl: './data-table-body.component.html',
  styleUrls: ['./data-table-body.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableBodyComponent {
  @HostBinding('class.data-table__body') class = true;
  @Input() section = '';
  @Input() numOfColumns: number;
  @Input() set isExpanded(val: boolean) {
    this.expanded = val;
  }

  @Output() sectionExpanded = new EventEmitter<boolean>();

  expanded = true;

  toggle(): void {
    this.expanded = !this.expanded;
    this.sectionExpanded.emit(this.expanded);
  }
}
